export default function CaseStudiesSection() {
  const caseStudies = [
    {
      title: '12-Unit Apartment Complex - Northeast El Paso',
      image: 'https://public.readdy.ai/ai/img_res/a16b149afe0702c96fb930bbd1c6fab8.jpg',
      situation: 'Owner inherited the property and lived out of state. The building had deferred maintenance issues and several problem tenants. Traditional buyers were scared off by the condition and tenant situations.',
      solution: 'We made a fair cash offer based on the property\'s income potential, not its current condition. We closed in 10 days through a local title company.',
      results: [
        'Closed in 10 days',
        'Owner received $1.2M cash',
        'No repairs required',
        'We handled all tenant issues'
      ]
    },
    {
      title: '24-Unit Garden Apartments - Central El Paso',
      image: 'https://readdy.ai/api/search-image?query=twenty%20four%20unit%20garden%20apartment%20complex%20central%20location%20multi%20family%20residential%20property%20courtyard%20style%20professional%20real%20estate%20photography%20clean%20simple%20background&width=700&height=500&seq=sellaptcase2&orientation=landscape',
      situation: 'Retiring owner wanted to sell quickly to relocate to another state. The property was well-maintained but the owner didn\'t want to wait 6-12 months for a traditional sale.',
      solution: 'We recognized the property\'s value and strong income stream. Made a competitive cash offer and closed in 14 days through the owner\'s preferred title company.',
      results: [
        'Closed in 14 days',
        'Owner received $2.8M',
        'Smooth tenant transition',
        'Owner relocated on schedule'
      ]
    },
    {
      title: '8-Unit Apartment Building - West El Paso',
      image: 'https://readdy.ai/api/search-image?query=eight%20unit%20apartment%20building%20west%20location%20small%20multi%20family%20property%20residential%20real%20estate%20investment%20property%20professional%20photography%20clean%20simple%20background&width=700&height=500&seq=sellaptcase3&orientation=landscape',
      situation: 'Partnership dispute between two owners who needed to liquidate the asset quickly. The property had some deferred maintenance and was only 70% occupied.',
      solution: 'We provided a fair valuation considering the occupancy rate and condition. Worked with both owners and their attorneys to structure a deal that satisfied everyone.',
      results: [
        'Closed in 12 days',
        'Partners received $680K',
        'Resolved ownership dispute',
        'Clean title transfer'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Success Stories
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Real Apartment Sales We've Completed
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These are actual apartment buildings we've purchased in El Paso. Every transaction was completed through a title company with satisfied sellers.
          </p>
        </div>

        <div className="space-y-12">
          {caseStudies.map((study, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-xl overflow-hidden ${
                index % 2 === 0 ? '' : ''
              }`}
            >
              <div className="grid lg:grid-cols-2 gap-0">
                <div className={`${index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'}`}>
                  <img 
                    src={study.image}
                    alt={study.title}
                    className="w-full h-full object-cover object-top min-h-[400px]"
                  />
                </div>
                <div className={`p-12 ${index % 2 === 0 ? 'lg:order-2' : 'lg:order-1'}`}>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">{study.title}</h3>
                  
                  <div className="mb-6">
                    <div className="text-sm font-bold text-teal-600 mb-2">THE SITUATION:</div>
                    <p className="text-gray-700 leading-relaxed">{study.situation}</p>
                  </div>

                  <div className="mb-6">
                    <div className="text-sm font-bold text-teal-600 mb-2">OUR SOLUTION:</div>
                    <p className="text-gray-700 leading-relaxed">{study.solution}</p>
                  </div>

                  <div>
                    <div className="text-sm font-bold text-teal-600 mb-3">RESULTS:</div>
                    <div className="grid grid-cols-2 gap-4">
                      {study.results.map((result, idx) => (
                        <div key={idx} className="flex items-start space-x-2">
                          <i className="ri-checkbox-circle-fill text-teal-600 flex-shrink-0 mt-1"></i>
                          <span className="text-gray-700 font-medium">{result}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            These are just three examples from our portfolio of 150+ apartment building purchases. We have the track record and expertise to handle your property sale professionally.
          </p>
          <a 
            href="tel://+19152065814"
            className="inline-block px-10 py-5 bg-teal-600 text-white rounded-lg font-bold text-lg hover:bg-teal-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-2"></i>
            Discuss Your Property - (915) 206-5814
          </a>
        </div>
      </div>
    </section>
  );
}